<div>
  <page-menu-item [imageUrl]='cc'
                  [menuItemName]='hh'
  ></page-menu-item>

</div>
